<script>
import Anxunheader from "@/views/Anxun/component/Anxunheader.vue";
import kefu from "@/views/kefu.vue";
import headtip from "@/views/headTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import { shareUrl } from "@/utils/vxshare";
import consultTip from "@/components/consultTip.vue";
// Constants for page content
const PAGE_CONTENT = {
  headertitle1: " Software customized design and development services\n\n",
  headertitle2: "Tailor-made software applications that meet customers' business needs to ensure efficient delivery and excellent performance \n\n",
  headerimg: require("@/assets/Inspection1.png"),
  introduce: "Based on safety regulations and industry standards, we build a knowledge base of potential hazards and risks, and combine it with multi-terminal technologies to achieve risk management and control, hazard detection, rectification, acceptance, and management. Through intelligent analysis, prediction and early warning, and safety performance management, we improve the efficiency of safety management and the ability to control risks.\n"
};

// 桌面版数据
const SECTION_DATA = [
  {
    title: "Business challenges and pain points",
    img: "/exploit1.png"
  },
  {
    title: "Service process",
    title2: "Demand analysis and architecture design",
    img: "/exploit2.png"
  },
  {
    title2: "Software development and testing",
    img: "/exploit3.png"
  },
  {
    title2: "Continuous iteration and optimization",
    img: "/exploit4.png"
  },
  {
    title2: "System integration and docking",
    img: "/exploit5.png"
  },
  {
    title: "Our advantages",
    img: "/exploit6.png"
  },
  {
    title: "Customer income",
    img: "/exploit7.png"
  }
];

const MOBILE_SECTION_DATA = SECTION_DATA.map(item => ({
  ...item,
  img: item.img.replace('exploit', 'exploit1')
}));

export default {
  name: 'SoftwareExploit',
  components: {
    bottomTip,
    kefuMobile,
    Anxunheader,
    kefu,
    headtip,
    consultTip,
  },
  data() {
    return {
      dialogVisible: false,
      title: '',
      model: false,
      texttotal: PAGE_CONTENT,
      data: SECTION_DATA,
      data2: MOBILE_SECTION_DATA
    };
  },
  methods: {
    setback(index) {
      return index % 2;
    },
    ResizeContainer() {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.model = screenWidth <= 700;
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      const metaKeywords = document.querySelector('meta[name="keywords"]');

      if (metaDescription) {
        metaDescription.setAttribute('content', this.texttotal.headertitle2);
      }
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.texttotal.headertitle1);
      }
    },
    setupShareData() {
      const url = window.location.href;
      const shareData = {
        url,
        pageTitle: this.texttotal.headertitle1,
        pageDescription: this.texttotal.headertitle2,
        pageKeywords: ''
      };
      shareUrl(shareData);
    },
    topTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    topTopmobile() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    clickConsult(item) {
      this.title = item;
      this.dialogVisible = true;
      sessionStorage.setItem('title', item);
    },
    hideDialog() {
      this.dialogVisible = false;
    }
  },
  mounted() {
    document.title = this.texttotal.headertitle1;
    this.setMetaTags();
    this.ResizeContainer();
    // window.addEventListener('resize', this.ResizeContainer);
  },
  created() {
    localStorage.setItem("home", 0);
    setTimeout(this.setupShareData, 1000);
  },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.ResizeContainer);
  // }
};
</script>

<template>
  <!-- Desktop Layout -->
  <div v-if="!model" ref="total" class="software-page">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="header-container">
      <headtip :changeVisable="changeVisable" @showDialog="showPartner" />
    </div>

    <kefu @toptop="topTop" />
    <Anxunheader :title1="texttotal.headertitle1" :title2="texttotal.headertitle2"
      @clickConsult="clickConsult('Software customized design and development services')" />

    <div v-for="(item, index) in data" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div>
  </div>

  <!-- Mobile Layout -->
  <div v-else ref="totalModel" class="software-page-mobile">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="mobile-header">
      <kefuMobile @topMobile="topTopmobile" />
      <headtip @showDialog="showPartner" />

      <div class="header-content">
        <div v-sliden-instep="{ duration: 800 }" class="logo-container">
          <img loading="lazy" src="@/assets/AnxunLogo.png" class="logo" />
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-red">
          {{ texttotal.headertitle1 }}
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-dark">
          {{ texttotal.headertitle2 }}
        </div>
      </div>

      <div class="header-footer">
        <div v-sliden-instep="{ duration: 2400 }" class="slogan">
          Oil & Gas Digitalization, Simple and Practical
        </div>
        <div class="inquiry-button" @click="clickConsult('Software customized design and development services')">
          Product Inquiry
        </div>
      </div>
    </div>

    <div v-for="(item, index) in data2" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div>

    <div ref="bottom">
      <bottomTip />
    </div>
  </div>

</template>

<style scoped lang="scss">
// 通用样式
.section-white {
  background-color: white;
}

.section-blue {
  background-color: #ebf1fd;
}

.section-image {
  margin: auto;
}

// 桌面版样式
.software-page {
  .header-container {
    height: 6vh;
    background-color: rgb(245 244 246);
    position: fixed;
    z-index: 10;
    padding-left: 3vw;
    width: 100%;
  }

  .content-section {
    padding: 5.78739184177998vh 8.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2.2060658579vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-image {
      width: 70vw;
    }
  }
}

// 移动版样式
.software-page-mobile {
  .mobile-header {
    position: relative;
    width: 100%;
    height: 670px;
    padding: 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../../assets/bannerModel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;

    .header-content {
      position: absolute;
      top: 65px;
      left: 9.17157712305026vw;
      z-index: 2;

      .logo-container {
        width: 120px;
        margin: 10px 0;
      }

      .logo {
        width: 100%;
      }

      .header-title {
        margin-top: 5px;
        width: 95%;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        line-height: 24px;

        &-red {
          font-weight: bolder;
          font-size: 20px;
          margin-top: 15px;
          line-height: 30px;
          color: #F44336;
        }

        &-dark {
          font-weight: bolder;
          margin-top: 15px;
          font-size: 18px;
          line-height: 28px;
          color: #2c3e50;
          text-align: left;
        }
      }
    }

    .header-footer {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);

      .slogan {
        width: 100vw;
        margin-bottom: 20px;
        font-weight: bolder;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        padding-bottom: 5px;
        color: #2f6dfd;
      }

      .inquiry-button {
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: auto;
        padding: 5px 4.6875vw;
        height: 35px;
        color: white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;
      }
    }
  }

  .content-section {
    padding: 5.78739184177998vh 2.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 6vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 5vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-image {
      width: 90vw;
    }
  }
}
</style>
